export default __webpack_public_path__ + "static/help_02_04_2-9ba8532801823f887ccea9ebf56ebdb2.png";